module.exports = __webpack_public_path__ + "img/img2.e4e49daa.jpg";